(ns frontend.ui.component.lp-portal.section.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]
   [garden.util :refer [space-join]]))

(defn section
  []
  {:width "100%"})

(defn header
  []
  {:padding       "8px 0"
   :border-bottom (space-join ["1px solid" (theme/color [:lp-report :section :border])])
   :font-size     "20px"
   :font-weight   "bold"
   :color         (theme/color [:lp-report :section :default])})

(defn content
  []
  {:margin-bottom "16px"
   :margin-top    "8px"})
